/**
 * Contact form behaviour.
 *
 * Three small jobs, none of which the form depends on to work:
 *
 *   1. Move focus to the confirmation after a successful send. Shopify handles
 *      the post with a full page reload, so without this the only thing that
 *      changed on the page is announced to nobody and a screen reader lands
 *      back at the top with no idea the message went.
 *   2. Hide the order-number field for the enquiries it makes no sense for.
 *      The field is rendered visible, so with this script blocked the form is
 *      merely longer than it needs to be -- never missing a field someone
 *      needed.
 *   3. Stop a second submit. The reload takes a moment on a slow connection,
 *      which is exactly when people press the button again and send the same
 *      message twice.
 */
(() => {
  const form = document.querySelector(".contact__form");
  if (!form) return;

  /* ---- 1. Confirmation ---------------------------------------------------
     Rendered only on the reload that follows a successful post, so its mere
     presence is the signal -- there is no state to read. */
  const success = document.querySelector("[data-contact-success]");
  if (success) {
    success.focus({ preventScroll: true });
    success.scrollIntoView({ block: "center", behavior: "smooth" });
    return;
  }

  /* ---- 2. Order number ---------------------------------------------------
     Disabled rather than merely hidden: a hidden-but-enabled input still
     posts, and an empty "Order number:" line in every enquiry email trains
     whoever reads them to skip the field on the ones where it matters. */
  const reason = form.querySelector("#contact-reason");
  const orderField = form.querySelector("[data-contact-order]");
  const orderInput = form.querySelector("#contact-order");

  if (reason && orderField && orderInput) {
    const sync = () => {
      const chosen = reason.selectedOptions[0];

      /* Before a reason is picked, keep the field: we do not yet know that it
         is irrelevant, and hiding it on load would make it flicker in. */
      const relevant = !chosen || !chosen.value || chosen.dataset.needsOrder === "true";

      orderField.hidden = !relevant;
      orderInput.disabled = !relevant;
      if (!relevant) orderInput.value = "";
    };

    reason.addEventListener("change", sync);
    sync();
  }

  /* ---- 3. Double submit --------------------------------------------------
     aria-disabled plus a submit guard, not the disabled property: a disabled
     button is removed from the tab order mid-interaction and stops announcing
     itself, so the person who pressed it loses their place. */
  const submit = form.querySelector(".contact__submit");
  if (!submit) return;

  let sent = false;

  form.addEventListener("submit", (event) => {
    /* Let the browser's own validation run first; a form that failed to
       validate has not been sent and must stay pressable. */
    if (!form.checkValidity()) return;

    if (sent) {
      event.preventDefault();
      return;
    }

    sent = true;
    submit.setAttribute("aria-disabled", "true");
    submit.querySelector("span").textContent = "Sending…";
  });
})();
